import { FormattedMessage } from 'react-intl';
import Spinner from '../../../images/global/spinner.svg';

const DataLoadingSpinner = () => (
  <div className="data-loading-spinner">
    <div className="dls-spinner">
      <Spinner style={{ width: 24, height: 24, fill: '#2855c3' }} />
    </div>
    <div className="dls-message">
      <FormattedMessage defaultMessage="Loading ..." />
    </div>
  </div>
);

export default DataLoadingSpinner;
